import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../../navigation-utils/useQueryParams';

import { useRunOnceWhenTruthy } from '../../../common/useRunOnceWhenTruthy';
import { buildConfigurationItemId } from '../../dependencies/helpers';

import {
  DependenciesContentViewType,
  SelectedDependencyWithClearHistoryProps,
} from '../../dependencies/types';
import { CardListItem } from './CardsList';
import { selectDocumentationActiveObjectData } from '../../../../reducers/documentation/documentationReducer';

export const useCardListHandleDeepLink = ({
  list,
  handleSetConfigurationItem,
}: {
  list: CardListItem[];
  handleSetConfigurationItem: (props: SelectedDependencyWithClearHistoryProps) => void;
}) => {
  const queryParams = useQueryParams();
  const allElements = useSelector(selectDocumentationActiveObjectData);
  const areElementsLoaded = Boolean(allElements);

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const item = list.find((item) => buildConfigurationItemId(item) === configurationItemId);
      if (item) {
        handleSetConfigurationItem({
          id: item.id,
          dependencyType: item.dependencyType,
          parentType: item.parentType,
          name: item.name,
          objectName: item.objectName,
          clearHistory: true,
          contentType: DependenciesContentViewType.default,
        });
      }
    }
  }, areElementsLoaded);
};
